import { render } from "./LayoutDefault.vue?vue&type=template&id=cf1c37da&ts=true"
import script from "./LayoutDefault.vue?vue&type=script&lang=ts"
export * from "./LayoutDefault.vue?vue&type=script&lang=ts"

import "./LayoutDefault.vue?vue&type=style&index=0&id=cf1c37da&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QHeader,QPageContainer});
